import { render } from "./taxes-model.vue?vue&type=template&id=43fdfe48"
import script from "./taxes-model.vue?vue&type=script&lang=js"
export * from "./taxes-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__